// ── Screen identifiers ────────────────────────────────────────────────────────

export const SCREENS = {
  UPLOAD: 'upload',
  GENERATING_STORIES: 'generating_stories',
  REVIEW_STORIES: 'review_stories',
  CREATING_JIRA: 'creating_jira',
  JIRA_SUCCESS: 'jira_success',
  GENERATE_TCS: 'generate_tcs',
  GENERATING_TCS: 'generating_tcs',
  REVIEW_TCS: 'review_tcs',
};

// ── Stepper config ────────────────────────────────────────────────────────────

export const WIZARD_STEPS = ['Upload doc', 'Review stories', 'Create in Jira', 'Generate TCs'];

export const STEPPER_INDEX = {
  [SCREENS.UPLOAD]: 0,
  [SCREENS.GENERATING_STORIES]: 0,
  [SCREENS.REVIEW_STORIES]: 1,
  [SCREENS.CREATING_JIRA]: 2,
  [SCREENS.JIRA_SUCCESS]: 2,
  [SCREENS.GENERATE_TCS]: 3,
  [SCREENS.GENERATING_TCS]: 3,
  [SCREENS.REVIEW_TCS]: 3,
};

// ── Modal titles ──────────────────────────────────────────────────────────────

export const MODAL_TITLE = {
  [SCREENS.UPLOAD]: 'Generate Jira Stories & Test Cases',
  [SCREENS.GENERATING_STORIES]: 'Generate Jira Stories & Test Cases',
  [SCREENS.REVIEW_STORIES]: 'Review Generated Jira Stories',
  [SCREENS.CREATING_JIRA]: 'Creating Stories in Jira…',
  [SCREENS.JIRA_SUCCESS]: 'Stories Created in Jira',
  [SCREENS.GENERATE_TCS]: 'Generate Test Cases',
  [SCREENS.GENERATING_TCS]: 'Generate Test Cases',
  [SCREENS.REVIEW_TCS]: 'Review Generated Test Cases',
};
export const TRANSITIONS = {
  [SCREENS.UPLOAD]: [SCREENS.GENERATING_STORIES],
  [SCREENS.GENERATING_STORIES]: [SCREENS.REVIEW_STORIES, SCREENS.UPLOAD], // success or error
  [SCREENS.REVIEW_STORIES]: [SCREENS.CREATING_JIRA, SCREENS.UPLOAD],
  [SCREENS.CREATING_JIRA]: [SCREENS.JIRA_SUCCESS],
  [SCREENS.JIRA_SUCCESS]: [SCREENS.GENERATE_TCS],
  [SCREENS.GENERATE_TCS]: [SCREENS.GENERATING_TCS, SCREENS.JIRA_SUCCESS],
  [SCREENS.GENERATING_TCS]: [SCREENS.REVIEW_TCS],
  [SCREENS.REVIEW_TCS]: [SCREENS.GENERATE_TCS],
};

// ── Placeholder TC data (replace with real API response) ─────────────────────

export const MOCK_TCS = [
  {
    id: 'tc1', selected: true,
    coverageTag: 'Happy path', coverageColor: '#22c55e',
    title: 'Verify PDF upload and story generation with valid document.',
    labels: ['Document upload', 'positive', 'AI gen'], stepsCount: 4,
  },
  {
    id: 'tc2', selected: true,
    coverageTag: 'Edge case', coverageColor: '#f59e0b',
    title: 'Verify behaviour when uploaded file exceeds 20 MB limit.',
    labels: ['File size', 'negative'], stepsCount: 0,
  },
  {
    id: 'tc3', selected: false,
    coverageTag: 'Negative', coverageColor: '#ef4444',
    title: 'Verify error message when unsupported file type is uploaded.',
    labels: ['Validation', 'error handling'], stepsCount: 3,
  },
];

// ── Description helpers ───────────────────────────────────────────────────────

const AC_DIVIDER = 'Acceptance Criteria';

/**
 * Builds the combined description string sent to CreateJiraIssueForm.
 * Story description first, acceptance criteria appended in a labelled block.
 */
export const buildCombinedDescription = (description, acceptanceCriteria = []) => {
  const parts = [];
  if (description) parts.push(description);
  if (acceptanceCriteria.length > 0) {
    parts.push(`\n\n${AC_DIVIDER}`);
    acceptanceCriteria.forEach((ac, i) => parts.push(`${i + 1}. ${ac}`));
  }
  return parts.join('\n');
};

/**
 * Splits the combined description string back into { description, acceptanceCriteria }.
 * Used in handleSaveEdits to reconcile edits made inside CreateJiraIssueForm.
 */
export const splitCombinedDescription = (fullText = '', fallbackAc = []) => {
  const dividerIdx = fullText.indexOf(AC_DIVIDER);
  if (dividerIdx === -1) return { description: fullText, acceptanceCriteria: fallbackAc };

  const description = fullText.slice(0, dividerIdx).trim();
  const acceptanceCriteria = fullText
    .slice(dividerIdx + AC_DIVIDER.length)
    .split('\n')
    .map((line) => line.replace(/^\d+\.\s*/, '').trim())
    .filter(Boolean);

  return { description, acceptanceCriteria };
};